// #region Imports
import { useWormhole } from "portal-vue";
// #endregion
export default class PortalVueFactory {
    // #region Vars
    _wormhole;
    // #endregion
    // #region Properties
    // #endregion
    // #region Constructor
    constructor(appHost) {
        // #region Store
        this._wormhole = useWormhole();
        // #endregion
    }
    // #endregion
    // #region Core
    hasForTarget(name) {
        return this._wormhole.transports.has(name);
    }
}
